import { render, staticRenderFns } from "./OldBaseFontSelect.vue?vue&type=template&id=768ff00a&"
import script from "./OldBaseFontSelect.vue?vue&type=script&lang=js&"
export * from "./OldBaseFontSelect.vue?vue&type=script&lang=js&"
import style0 from "./OldBaseFontSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports